import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Data from './pages/Data';
import About from './pages/About';
import Contact from './pages/Contact';
import ContactPyrrus from './pages/ContactPyrrus';
import QuoteForm from './pages/QuoteForm';
import PrivacyPolicy from './pages/PrivacyPolicy';
import LegalNotice from './pages/LegalNotice';
import Demo from './pages/Demo';
import './styles/App.css';

function App() {
  return (
    <Router>
      <div className="app">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
             <Route path="/contact-pyrrus" element={<ContactPyrrus />} />
            <Route path="/devis-gratuit" element={<QuoteForm />} />
            <Route path="/politique-de-confidentialite" element={<PrivacyPolicy />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/data" element={<Data />} />
            <Route path="/mentions-legales" element={<LegalNotice />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;